import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { StatusStatusPurchaseTypes } from 'shared/constants'
import { copyText } from 'shared/lib//copyText'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { MBonusIcons } from 'shared/ui/mbonus/mbonus-icons'
import { message } from 'shared/ui/message'
import { StatusBought } from 'shared/ui/status-bought'

import styles from './styles.module.scss'

interface Props {
  pnrNumber?: string
  bonusAmount?: string
  numberTicket?: string
  price?: number | string
  status: StatusStatusPurchaseTypes
}

const CopyNumberTicket: FC<Props> = ({
  price,
  status,
  pnrNumber,
  bonusAmount,
  numberTicket,
}) => {
  const { t } = useTranslation()

  const onCopyOrderId = (orderNumber?: string) => {
    if (!orderNumber) return

    message.copy(t('copied_to_clipboard'))
    copyText(orderNumber)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.label}>{t('beket.order_detail')}</span>
        <StatusBought status={status} />
      </div>

      <div className={styles.block_list}>
        {numberTicket && (
          <div className={styles.block}>
            <div className={styles.info}>
              <span className={clsx('regular-12', styles.info_label)}>
                {t('order_number')}
              </span>
              <p className={clsx('regular-14', styles.info_value)}>
                {numberTicket}
              </p>
            </div>

            <AppIcon
              id={AllIcons.COPY_NEW}
              className={styles.icon}
              width={20}
              height={20}
              onClick={() => onCopyOrderId(numberTicket)}
            />
          </div>
        )}

        {pnrNumber && (
          <div className={styles.block}>
            <div className={styles.info}>
              <span className={clsx('regular-12', styles.info_label)}>
                {t('pnr_number')}
              </span>
              <p className={clsx('regular-14', styles.info_value)}>
                {pnrNumber}
              </p>
            </div>

            <AppIcon
              id={AllIcons.COPY_NEW}
              className={styles.icon}
              width={20}
              height={20}
              onClick={() => onCopyOrderId(pnrNumber)}
            />
          </div>
        )}

        <div className={styles.block}>
          <div className={styles.info}>
            <span className={clsx('regular-12', styles.info_label)}>
              {t('price')}
            </span>

            <div className={styles.cashbackInfo}>
              <p className={clsx('regular-14', styles.info_value)}>
                {priceShow(String(price))} &#8384;
              </p>

              {!!bonusAmount && <MBonusIcons text={priceShow(bonusAmount)} />}
            </div>
          </div>
        </div>

        {!!bonusAmount && (
          <div className={styles.block}>
            <div className={styles.info}>
              <span className={clsx('regular-12', styles.info_label)}>
                {t('mbonus_popup.info_text')}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CopyNumberTicket
